
import utils from '@/util/index'
import {defineComponent, reactive, onBeforeMount, nextTick} from 'vue'
import {useRoute,useRouter} from "vue-router";
import {getTslPhotoInfo} from '@/service'
import { Toast } from 'scvant';


import Swiper from 'swiper';
import 'swiper/dist/css/swiper.css';
    interface State {
        isPc: number;
        currentTabIndex: number;
        renderList: any;
        photoList: object[];
        photoViewer: any;
        slideIndex: number;
        currentGroupLength: number;
        currentSlideIndex: number;
        showSwiper: boolean;
        reportCode: any;
        vin: any;
    }

    export default defineComponent({
        setup(ctx: any) {
            let state: State = reactive({
                reportCode: '',
                vin: '',
                isPc: 0,
                currentTabIndex: 0,
                slideIndex: 0,
                photoList: [],
                photoViewer: {},
                currentGroupLength: 0,
                currentSlideIndex: 1,
                showSwiper: false,
                renderList: []
                // ,{
                //     title: '存证照片',
                //     photoList: []
                // },{
                //     title: '缺陷照片',
                //     photoList: []
                // }
            });
            state.isPc = utils.getUserBrowser()
            const {query} = useRoute();
            const {reportCode, templateCode} = query;
            state.reportCode = reportCode;
            Toast.loading({
                duration: 0,
                forbidClick: true,
                message: '加载中...',
            });
            function setCurrentIndex (index) {
                let imgListLenV = state.photoList.length;
                console.log('setCurrentIndex:', index);
                let len0 = state.renderList[0].photoList.length;
                let len1 = state.renderList[0].photoList.length + state.renderList[1].photoList.length;
                let len2 = len1 + state.renderList[2].photoList.length;
                // debugger;
                if (index <= len0-1) {
                    state.currentTabIndex = 0;
                    state.currentSlideIndex = index + 1;
                } else if (len0-1 < index && index <= len1-1) {
                    state.currentTabIndex = 1;
                    state.currentSlideIndex = index - len0 + 1;
                } else if (len1-1 < index && index <= len2-1) {
                    state.currentTabIndex = 2;
                    state.currentSlideIndex = index - len1 + 1;
                } 
                state.currentGroupLength = state.renderList[state.currentTabIndex].photoList.length;

                console.log('tabIndex:', state.currentTabIndex);
            }
            getTslPhotoInfo({reportCode, templateCode}).then((res: any) => {
                console.log(res);
                // state.renderList[0].photoList = res.photoList;
                state.renderList = res.photoModuleVOS;
                state.vin = res.vin;
                // state.renderList[1].photoList = res.markPhotoList;
                // state.renderList[2].photoList = res.defectPhotoList;
                for (let i=0;i<state.renderList.length;i+=1) {
                    let item = state.renderList[i];
                    state.photoList = [...state.photoList, ...item.photoList];
                }
                state.currentGroupLength = state.renderList[0].photoList.length;
                console.log('list:', state.photoList);
                nextTick(()=>{
                    // 初始化swiper
                    state.photoViewer = new Swiper('.swiper', {
                        initialSlide: state.slideIndex,
                        keyboard: true,
                        direction: 'horizontal',
                        navigation: {
                            nextEl: '.nextBtn',
                            prevEl: '.prevBtn',
                        },
                        loop: false,
                        zoom: true,
                        preloadImages: true,
                        observer: true,// 修改swiper自己或子元素时，自动初始化swiper
                        observeParents: true,// 修改swiper的父元素时，自动初始化swiper
                        on: {
                            slideChange: function () {
                                console.log('swiperComponent--slideChange,activeIndex:', this.activeIndex);
                                state.currentSlideIndex = Number(this.activeIndex) + 1;
                                // setCurrentIndex(this.activeIndex); // 通过当前索引确定所在分组图片数量
                                // console.log('swiperComponent--state.defectList:', JSON.stringify(state.defectList));
                                
                                // state.photoName = (state.imgList[this.activeIndex] as any).remark || (state.imgList[state.slideIndex] as any).photoName;
                                // 抛出切换事件
                                // let item = {
                                //     index: this.activeIndex,
                                //     // item: imgList[this.activeIndex - 1],
                                //     tabIndex: state.currentTabIndex
                                // }
                                // ctx.emit('slideChange', item)
                            },
                        }
                    })
                })
                Toast.clear();
            }).catch((err) => {
                console.error(err)
            })
            // const {query} = useRoute()
            // const router = useRouter()
            // 判断当前机型 移动端的话带着所有参数跳转/h5 pc端的话带着所有参数跳转/pc
            
            
            return{
                state
            }
        },
        components: {
        },
        methods: {
            openImgViewer (groupIndex, photoIndex) {
                let prevLength = 0;
                for (let i=0; i < groupIndex; i += 1) {
                    prevLength += this.state.renderList[i].photoList.length;
                }
                this.state.slideIndex = prevLength + photoIndex;
                this.state.currentSlideIndex = photoIndex + 1;
                this.state.currentGroupLength = this.state.renderList[groupIndex].photoList.length;
                this.state.showSwiper = true;
                this.state.photoViewer.slideTo(this.state.slideIndex);
            },
            goGroup (groupIndex) {
                this.state.currentTabIndex = groupIndex;
                if (this.state.showSwiper) {
                    let prevLength = 0;
                    for (let i=0; i < groupIndex; i += 1) {
                        prevLength += this.state.renderList[i].photoList.length;
                    }
                    this.state.photoViewer.slideTo(prevLength);
                } else {
                    let groupTitle: any = document.getElementById(`listItemGroup_${groupIndex}`);
                    let topFix: any = document.getElementById('topFixed');
                    let fixHei = topFix.offsetHeight;
                    let offsetTop = groupTitle.offsetTop;
                    window.scrollTo(0, offsetTop - fixHei - 10);
                }
            },
            closeSwiper () {
                this.state.showSwiper = false;

            }
        }
         
    })
